namespace TabAurous.Finance {
    export interface PDCClearanceForm {
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        PDCTypeId: PDCTypeEditor;
        CreatedBy: Serenity.LookupEditor;
        Details: PDCClearanceDetailsEditor;
        Narration: Serenity.TextAreaEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class PDCClearanceForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.PDCClearance';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PDCClearanceForm.init)  {
                PDCClearanceForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = PDCTypeEditor;
                var w3 = s.LookupEditor;
                var w4 = PDCClearanceDetailsEditor;
                var w5 = s.TextAreaEditor;
                var w6 = s.IntegerEditor;

                Q.initFormType(PDCClearanceForm, [
                    'TransDate', w0,
                    'VoucherNo', w1,
                    'PDCTypeId', w2,
                    'CreatedBy', w3,
                    'Details', w4,
                    'Narration', w5,
                    'VoucherTypeId', w6,
                    'CompanyId', w6,
                    'FinancialYearId', w6
                ]);
            }
        }
    }
}
